<template>
  <div>
    <VueSlimTable
      ref="table"
      :source="() => facebookAccounts"
      :columns="columns"
      class="responsive-table borderless-table m-0">
      <template #row="{ row }">
        <TableRow :row="row" />
      </template>
    </VueSlimTable>
  </div>
</template>

<script>
import TableRow from './table_row'

export default {
  components: { TableRow },
  props: {
    facebookAccounts: { type: Array, default: () => []}
  },
  created() {
    this.columns = [
      { key: 'profileName', title: 'Profile Name' },
      { key: 'allowedScopes', title: 'Allowed Scopes' },
      { key: 'syncLastAt', title: 'Sync Last At' },
      { key: 'disconnectedAt', title: 'Disconnected At' },
      { key: 'actions', title: '' }
    ]
  }
}
</script>
